;(async () => {
  const { default: moment } = await import('moment')
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './offers-block-tabbed.scss')]).then(() => {
    $('.widget.offers-block-tabbed').each(function (i, el) {
      $(el).data('widget', new OffersBlockTabbed(el, Swiper, moment))
      $(el).data('widget').init()
    })
  })
})()

function OffersBlockTabbed(el, Swiper, moment) {
  const self = this
  self.el = $(el)
  self.swiperEl = self.el.find('.swiper')
  self.tabsData = {}
  self.cardsData = []
  self.tabTemplate = require('./offer-block-tab.hbs')
  self.cardTemplate = require('./offer-block-card.hbs')
  // allowedStates is used in many places, so we parse it once here
  self.allowedStates = parseDataAttribute('data-allowed-states')
  // Lookup table for state display names
  self.stateDisplayNameByStateCode = self.allowedStates.reduce((acc, state) => {
    acc[state.stateCode] = state.displayName
    return acc
  }, {})
  // Lookup table for state display limits
  self.stateDisplayLimitsByStateCode = self.allowedStates.reduce((acc, state) => {
    acc[state.stateCode] = state.displayLimit
    return acc
  }, {})

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('OffersBlockTabbed init', self)
    }
    self.el.css('opacity', 1)

    self.fetchData()
  }

  self.hideWidget = function () {
    console.warn('No offers to display, hiding widget.', self.el)
    self.el.addClass('!hidden')
    self.el.css('opacity', 0)
  }

  self.showWidget = function () {
    self.el.removeClass('!hidden')
    self.el.css('opacity', 1)
  }

  self.fetchData = function () {
    const endpoint = self.el.attr('data-api-endpoint')
    const method = self.el.attr('data-api-method')
    const gdayCaller = self.el.attr('data-api-gday-caller')

    if (!gdayCaller) {
      console.error('No Gday-Caller header provided for OffersBlockTabbed')
      return
    }

    if (!endpoint && !method) {
      console.error('No API endpoint or method defined for OffersBlockTabbed')
    }

    $.ajax({
      url: endpoint,
      type: method,
      contentType: 'application/json',
      headers: {
        'Gday-Caller': gdayCaller,
      },
    })
      .done(function (res) {
        console.log('fetchData', res)

        // If res has 0 or 1 items, hide this widget
        if (res.length > 1) {
          const filteredData = self.filterData(res)
          const sortedData = self.sortData(filteredData)
          self.formatData(sortedData)
        } else {
          self.hideWidget()
        }
      })
      .fail(function () {
        self.hideWidget()
        console.error('Failed to fetch data for OffersBlockTabbed', endpoint, method)
      })
  }

  function parseDataAttribute(attrName, fallback = []) {
    if (!attrName.startsWith('data-')) {
      console.warn(`Invalid attribute: ${attrName}`)
      return fallback
    }

    const raw = self.el.attr(attrName)
    if (!raw || !raw.trim()) return fallback

    try {
      const normalized = raw.replace(/'/g, '"')
      const parsed = JSON.parse(normalized)

      return parsed
    } catch (e) {
      console.warn(`Failed to parse ${attrName}:`, raw)
      return fallback
    }
  }

  self.sortData = function (data) {
    // Sort data by endUtc in ascending order
    return data.sort((a, b) => {
      const dateA = moment(a.endUtc)
      const dateB = moment(b.endUtc)
      return dateA - dateB
    })
  }

  self.filterData = function (data) {
    let filteredData = data

    // Filter by allowed states
    const allowedStateCodes = self.allowedStates.map((state) => state.stateCode)
    console.log('allowedStateCodes', allowedStateCodes)
    if (allowedStateCodes.length > 0) {
      filteredData = filteredData.filter((item) => {
        return allowedStateCodes.includes(item.park.address.state)
      })
    }

    // Filter by allowed parks
    const allowedParks = parseDataAttribute('data-allowed-parks')
    console.log('allowedParks', allowedParks)
    if (allowedParks.length > 0) {
      filteredData = filteredData.filter((item) => {
        return allowedParks.includes(item.parkCode)
      })
    }

    // Filter by allowed offers
    const allowedOffers = parseDataAttribute('data-allowed-offers')
    console.log('allowedOffers', allowedOffers)
    if (allowedOffers.length > 0) {
      filteredData = filteredData.filter((item) => {
        return allowedOffers.includes(item.dealCode)
      })
    }

    // Only offers that are still active
    const nowUtc = moment.utc() // current time in UTC
    filteredData = filteredData.filter((item) => moment(item.endUtc) >= nowUtc)

    return filteredData
  }

  self.formatData = function (data) {
    function createEndsInLabel(endDateUtc) {
      if (!endDateUtc) {
        console.error('No end date provided')
        return ''
      }

      // Determine how many days until the offer ends
      const endUtc = moment(endDateUtc)
      const nowUtc = moment.utc() // current time in UTC
      const diffInDays = endUtc.diff(nowUtc, 'days')

      // Return label based on the number of days remaining
      if (diffInDays === 0) {
        return 'Ends today'
      } else if (diffInDays === 1) {
        return 'Ends in 1 day'
      } else {
        return `Ends in ${diffInDays} days`
      }
    }

    function simplifyConditions(conditionsArr) {
      // get 'description' from each object in the array
      let conditions = conditionsArr.map((c) => {
        return c.description
      })
      // Return only first 4 items
      return conditions.slice(0, 4)
    }

    // Loop through data and get tabs and cards data needed to render the UI
    data.map((item) => {
      // Create tabs data object
      // Build an object with state as key and array of deal IDs as value we can use to
      //   1. know how many offers per state and
      //   2. be able to retrieve cards by id for a given state

      const stateCode = item.park.address.state
      if (!self.tabsData[stateCode]) self.tabsData[stateCode] = []

      // Enforce display limit by State
      const displayLimit = self.stateDisplayLimitsByStateCode[stateCode]
      if (displayLimit && self.tabsData[stateCode].length >= displayLimit) {
        console.warn(`State ${stateCode} has reached its display limit of ${displayLimit}. Not adding more offers.`)
        // Do not add this item if we reached the limit
        return
      }

      // Add offer to tabsData
      self.tabsData[stateCode].push(item.id)

      // Add offer to cardsData
      // Simplify the data to only include the fields we need to render the cards
      self.cardsData.push({
        id: item.id,
        applyUrl: `/deals/${item.parkCode}/${item.dealCode}/apply`,
        parkCode: item.parkCode,
        dealCode: item.dealCode,
        imageUrl: item.promotionalContent.imageUrl,
        dealTagLabel: item.description, // HPR-376 do not use 'item.promotionalContent.text'
        suburb: item.park.address.suburb,
        state: item.park.address.state,
        conditions: simplifyConditions(item.eligibility.conditions),
        endUtc: item.endUtc,
        endsInLabel: createEndsInLabel(item.endUtc),
      })
    })

    // Do not allow tabs with only 1 offer to be shown
    for (const stateId in self.tabsData) {
      if (self.tabsData[stateId].length === 1) {
        delete self.tabsData[stateId]
      }
    }

    // If there are no tabs, hide the widget
    if (Object.keys(self.tabsData).length === 0) {
      self.hideWidget()
      return
    }

    // Get default state
    let defaultStateId = self.el.attr('data-default-state')
    if (!defaultStateId) {
      // Get first tab we can find
      const [stateId] = Object.entries(self.tabsData)[0]
      defaultStateId = stateId
    }

    // Render tabs
    self.renderTabs(self.tabsData, defaultStateId)

    // Render cards
    const cardsData = self.getCardsByStateId(defaultStateId)
    self.renderCards(cardsData)

    // Initialize the swipers now we have tabs and cards in the DOM
    self.initTabsSwiper(defaultStateId)
    self.initSwiper()
  }

  self.getCardsByStateId = function (stateId) {
    const cardsData = self.cardsData.filter((datum) => {
      return datum.state === stateId
    })

    // Return cards for the given state ID
    return cardsData
  }

  self.renderTabs = function (tabsData, activeTabId) {
    // Sort tabs (reorder)
    const sortedTabsData = Object.fromEntries(
      self.allowedStates
        .map((state) => state.stateCode)
        .filter((code) => code in tabsData) // only include existing keys
        .map((code) => [code, tabsData[code]]),
    )

    // Create tabs HTML from sotredTabsData
    const tabsFragment = new DocumentFragment()
    Object.keys(sortedTabsData).forEach((key) => {
      // Render the tab
      const template = document.createElement('template')
      const stateDisplayName = self.stateDisplayNameByStateCode[key.toUpperCase()]
      template.innerHTML = self.tabTemplate({
        id: key,
        label: stateDisplayName,
        count: sortedTabsData[key].length, // number of offers in this state
      })
      tabsFragment.append(template.content)
    })

    // Append tabs to the DOM
    const tabsContainerEl = self.el.find('.js-tabs-container')
    tabsContainerEl.append(tabsFragment)

    // Set the active tab
    const activeTabEl = tabsContainerEl.find(`button[data-state-id="${activeTabId}"]`)
    if (activeTabEl) {
      activeTabEl.addClass('is-active')
    } else {
      // find first and set active
      const firstTabEl = tabsContainerEl.find('button').first()
      firstTabEl.addClass('is-active')
    }

    // Handle tab click events
    self.bindTabClickEvents()
  }

  self.bindTabClickEvents = function () {
    const tabsContainerEl = self.el.find('.js-tabs-container')
    // Find all buttons
    let tabButtons = tabsContainerEl.find('button')
    tabButtons.each(function (i, el) {
      // Bind click event
      $(el).on('click', function (e) {
        const stateId = $(this).attr('data-state-id')
        const cardsData = self.getCardsByStateId(stateId)
        // Check if state has limit on number of offers, and slice data if needed
        self.renderCards(cardsData)

        // Update the active tab
        tabButtons.removeClass('is-active')
        $(this).addClass('is-active')

        // Update slides count

        // Update the swiper to show the first slide
        self.swiper.update()
        self.swiper.slideTo(0)
      })
    })
  }

  self.renderCards = function (cardsData) {
    // Clear existing cards
    const cardsContainerEl = self.el.find('.js-cards-container')
    cardsContainerEl.empty()

    // TODO: Check if we have rendered cards already, and just update DOM instead of re-rendering

    // Create cards HTML
    const cardsFragment = new DocumentFragment()
    cardsData.forEach((datum) => {
      const template = document.createElement('template')
      template.innerHTML = self.cardTemplate(datum)
      cardsFragment.append(template.content)
    })

    // Append cards to the DOM
    cardsContainerEl.append(cardsFragment)

    // Update data-slides-count attribute on the swiper element
    self.swiperEl.attr('data-slides-count', cardsData.length)
  }

  self.initTabsSwiper = function (defaultStateId) {
    const swiperEl = self.el.find('.tabs-swiper')
    self.tabsSwiper = new Swiper(swiperEl, {
      watchOverflow: true, // Prevent slides moving on drag if they do not overflow
      slidesPerView: 'auto',
    })

    // slideTo the active tab
    const keys = Object.keys(self.tabsData)
    const activeTabIndex = keys.indexOf(defaultStateId)
    if (activeTabIndex !== -1) {
      self.tabsSwiper.slideTo(activeTabIndex)
    }
  }

  self.initSwiper = function () {
    if (!self.swiperEl) {
      self.swiperEl = self.el.find('.swiper')
    }

    // Find all slides in the swiper
    const slides = self.swiperEl.find('.swiper-slide')
    self.swiperEl.attr('data-slides-count', slides.length)

    // Buttons are not within the self.swiperEl, but within the parent element
    const nextEl = self.el.find('.swiper-button-next')
    const prevEl = self.el.find('.swiper-button-prev')
    nextEl.removeClass('!hidden')
    prevEl.removeClass('!hidden')

    self.swiper = new Swiper(self.swiperEl, {
      loop: false,
      autoHeight: false,
      watchOverflow: true,
      slidesPerView: 'auto',
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: self.swiperEl.find('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },
    })
  }
}
